import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import "./assets/css/main.css";
import "./assets/scss/impactdriver_scss/impactdriver_main.scss";
import router from "./router";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

app.config.globalProperties.$url = location.protocol + "//" + location.host;
app.config.globalProperties.$port = "";
export const globals = app.config.globalProperties;

if (location.host === "app.impactpilot.io") {
  Sentry.init({
    app,
    dsn: "https://a0dc7ab651fd4d489f6f484741e0b379@o4505555003244544.ingest.us.sentry.io/4505555004358656",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
  });
}

app.use(createPinia());
app.use(router);
app.use(ElementPlus);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  // registering ElementPlusIcons
  app.component(key, component);
}

app.mount("#main-wrapper");
